import {BrowserRouter} from 'react-router';
import {ErrorBoundary} from '../common/ErrorBoundary';
import {configuration} from '../config';
import {FirebaseConfigHelp} from '../firebase/FirebaseConfigHelp';
import {I18nProvider} from '../i18n/I18nProvider';
import {AppInstallFunctionsProvider} from '../pwa/AppInstallFunctions';
import {ComponentWithoutChildren} from '../react/types';
import {AppRoutes} from '../routes/AppRoutes';
import {isRunningInUnitTest} from '../tests/testUtils';
import {AppLoading} from './AppLoading';

// Note: ErrorBoundary uses translations so must be a child of I18nProvider
export const App: ComponentWithoutChildren = () => {
  /* v8 ignore next -- @preserve */
  if (!Object.keys(configuration.firebase).length && !isRunningInUnitTest()) {
    // TODO remove this block once firebase configuration is complete
    return <FirebaseConfigHelp />;
  }

  /*
   * Note: AppInstallFunctionsProvider must appear at or near the top of the tree
   * because if it unmounts and remounts it will lose the app install event handler
   * reference that was captured in useAppInstallPrompt.
   */
  return (
    <AppInstallFunctionsProvider>
      <AppLoading>
        <I18nProvider>
          <ErrorBoundary>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </ErrorBoundary>
        </I18nProvider>
      </AppLoading>
    </AppInstallFunctionsProvider>
  );
};
